/**
 * 일괄 채점 청크 내부 진행률 계산.
 *
 * 배경: 기존 로직은 "예상 시간 대비 경과 비율 x 0.9"로 진행률을 채워서
 * 실제 채점이 예상(텍스트 60초/이미지 180초)보다 오래 걸리면
 * 구간의 90% 지점에서 완전히 얼어붙었다. 프로덕션 실측으로 텍스트 청크가
 * 2~4분, 이미지 청크가 10분 이상 걸리는 사례가 있어 "멈췄다"는 오인이 잦았다.
 *
 * 새 곡선: 예상 시간 안에는 구간의 85%까지 선형으로 차오르고,
 * 그 뒤에는 98%를 향해 점근적으로 계속 움직인다 (절대 멈추지 않고, 절대 완료처럼 보이지 않음).
 */

export const BATCH_CHUNK_LINEAR_FILL = 0.85;
export const BATCH_CHUNK_MAX_FILL = 0.98;

/**
 * @param {number} elapsedMs - 청크(또는 학생) 시작 이후 경과 시간
 * @param {number} expectedMs - 예상 소요 시간
 * @returns {number} 진행 구간을 채울 비율 (0 ~ BATCH_CHUNK_MAX_FILL 미만)
 */
export function computeChunkFillRatio(elapsedMs, expectedMs) {
  if (!expectedMs || expectedMs <= 0) return 0;
  const ratio = elapsedMs / expectedMs;
  if (ratio <= 0) return 0;
  if (ratio <= 1) return ratio * BATCH_CHUNK_LINEAR_FILL;
  return (
    BATCH_CHUNK_LINEAR_FILL
    + (BATCH_CHUNK_MAX_FILL - BATCH_CHUNK_LINEAR_FILL) * (1 - Math.exp(-(ratio - 1) / 2))
  );
}
